//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("../../common/functions/is-empty");

export function validateApprovalInput(data) {
  let validationErrors = {};

  data.comments = !isEmpty(data.comments) ? data.comments : "";
  if (Validator.isEmpty(data.comments)) {
    validationErrors.comments = "Approval/Rejection reason is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
